var map = {
	"./customer/routes.js": 79834,
	"./material/routes.js": 27921,
	"./product/routes.js": 32403,
	"./project/routes.js": 73621,
	"./quotation/routes.js": 2948,
	"./rating/routes.js": 27533,
	"./report/routes.js": 15712,
	"./service/routes.js": 80139,
	"./settings/routes.js": 63201,
	"./ticket/routes.js": 35318,
	"./user/routes.js": 911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2510;